import { ReactNode } from 'react';
import { Group, Tooltip } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { ORBIT_GRAY } from '@/theme/colors';

interface LockedValueProps {
  children: ReactNode;
  /** Why only the system can change it now, on hover. */
  reason: string;
}

/**
 * A value only the system may change now: the value, a small lock, and the reason on hover — no
 * chevron and no Change link (`patient-profile.mdx`). A genuine correction is an admin fix.
 */
export function LockedValue({ children, reason }: LockedValueProps) {
  return (
    <Tooltip label={reason} withArrow position="top-start">
      <Group gap={5} wrap="nowrap" style={{ display: 'inline-flex' }}>
        {children}
        <IconLock
          size={11}
          stroke={1.6}
          aria-label={reason}
          data-testid="panel-lock"
          style={{ color: ORBIT_GRAY, flexShrink: 0 }}
        />
      </Group>
    </Tooltip>
  );
}
